/*
{
  title: 'Economic Analysis",
  categories: [
    {
      category: "General view",
      relevance: 5,
      order: 1
      "topics": [
        { relevance: 5, "name": "Region", "descr": "Region", order: 1 },
        { relevance: 3, "name": "Capital", "descr": "Capital" },
        { relevance: 4, "name": "Currency", "descr": "Official Currencies" },
        {
          relevance: 2,
          "name": "Ease of doing business",
          "descr": "Ease of doing business ranks economies from 1 to 190, with first place being the best. A high ranking (a low numerical rank..."
        }
    }
  ]
}
*/

// const ObjectID = require("bson-objectid");
import ObjectID from 'bson-objectid';

const props=['_id','template','user','categories', 'templateId']

const final=function(data={}) {
  const ret=props.reduce((accum,curr)=>{
    if(data[curr]) {
      return {...accum,[curr]:data[curr]}
    }
    return {...accum,[curr]:this[curr] || ''};
  },{});

  // Template ID
  if(!ret.templateId) {
    ret.templateId=ret._id;
  }

  if(!ret.categories) {
    ret.categories=[];
  }
  return ret;
}

export default (data)=>{

  data=final.call({},data);

  data.categories=data.categories.filter(elem=>elem.category!=='Other');

  // sorting
  data.categories.forEach((cat,index)=>{
    if(!cat.topics) cat.topics=[];
    if(!cat._id) cat._id=ObjectID().toHexString();
    cat.topics=cat.topics.map((topic,index)=>{
      const {relevance}=topic;
      // if(!order) topic.order=(index+1);
      topic.order=(index+1);
      if(relevance === undefined || relevance === null) topic.relevance=0;
      return topic;
    });
    cat.topics.sort((a,b)=>a.order > b.order ? 0 : 1);
    if(cat.relevance === undefined) cat.relevance=0;
    // if(!cat.order) cat.order=(index+1);
    cat.order=(index+1);
  });

  data.categories.sort((a,b)=>a.order > b.order ? 0 : 1);

  data.final=final;

  return data;
}